module.exports = __webpack_public_path__ + "img/SKMJ_protect3.112c0d3d.jpg";